import React, { Component } from "react";
import SeparateProtein from "./component";
import { injectIntl, FormattedMessage } from "react-intl";

import "./styles.scss";

class SeparateProteinPredictions extends Component {
  render() {
    return (
      <div className="Predictions">
        <div className="cell-culture-interaction">
          <div className="protein-band-results">
            <h4 className="heading">
              <FormattedMessage
                id={this.props.heading}
                defaultMessage={this.props.heading}
                description=""
              />
            </h4>
            <p>
              <FormattedMessage
                id={this.props.description}
                defaultMessage={this.props.description}
                description=""
              />
            </p>
            <SeparateProtein
              component_type={this.props.component_type}
              bands={this.props.bands}
              editable={this.props.editable}
              intl={this.props.intl}
              component_strings={this.props.component_strings}
            />
          </div>
        </div>
      </div>
    );
  }
}

const enhancedComponent = injectIntl(SeparateProteinPredictions);
export default enhancedComponent;
